export default [
    {
        code: 'permissions',
        name: '权限管理',
        selfFlg: 'permission',
        icon: 'el-icon-s-home',
        parentKey: '',
        children: [
            {
                code: 'tenant',
                name: '租户管理',
                selfFlg: 'tenant',
                parentKey: 'permissions'
            },
            {
                code: 'role',
                name: '角色管理',
                selfFlg: 'role',
                parentKey: 'permissions'
            },
            {
                code: 'dataSource',
                name: '数据源管理',
                selfFlg: 'datasource',
                parentKey: 'permissions'
            }
        ]
    }
];
